export const BROADCAST_TABLE_KEYS = {
  PREV_BROADCAST_LIST_INDEX: 'prevBroadcastListIndex',
  MORE_BROADCAST_LIST_INDEX: 'moreBroadcastListIndex',
  IS_PREV_BROADCAST_DATA_EXIST: 'isPrevBroadcastData',
  SELECTED_BROADCAST_DATE: 'broadcastTableSelectedDate',
  BROADCAST_LIST: 'broadcastList',
  BROADCAST_COUNT: 'broadcastCount',
  GET_PREV_NEXT_BROADCAST_LIST: 'getPrevNextBroadcastList',
  GET_TODAY_BROADCAST_LIST: 'getTodayBroadcastList',
} as const
